"use client";

import { useEffect, useRef, useState } from "react";
import EditorJS from "@editorjs/editorjs";
import Header from "@editorjs/header";
import List from "@editorjs/list";
import CodeTool from "@editorjs/code";
import Delimiter from "@editorjs/delimiter";
import InlineCode from "@editorjs/inline-code";
import ImageTool from "@editorjs/image"; // Đảm bảo bạn đã cài đặt @editorjs/image
import Table from "@editorjs/table";
import edjsHTML from "editorjs-html";
import parse from "html-react-parser";
import { UPLOAD_FILES_URL } from "constant";
const edjsParser = edjsHTML();

interface IFullEditorJS {
  content?: string;
  onChange?: (value: string) => void;
}

export default function FullEditorJS(props: IFullEditorJS) {
  const editorRef = useRef<EditorJS | null>(null);
  const [html, setHtml] = useState<string[]>([]);

  // Hàm upload tùy chỉnh cho EditorJS
  const handleImageUpload = async (file: File): Promise<{ success: number; file: { url: string } }> => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("POST", UPLOAD_FILES_URL, true);

      const formData = new FormData();
      formData.append("file", file, file.name);

      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable) {
          const progress = (e.loaded / e.total) * 100;
          console.log(`Upload progress: ${progress}%`);
          // Bạn có thể cập nhật trạng thái tải lên ở đây nếu cần
        }
      };

      xhr.onload = () => {
        if (xhr.status === 403) {
          reject({ message: "HTTP Error: " + xhr.status, remove: true });
          return;
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          reject("HTTP Error: " + xhr.status);
          return;
        }

        try {
          const json = JSON.parse(xhr.responseText);
          const imageUrl = json?.data[0]?.url;

          if (!json || typeof imageUrl !== "string") {
            reject("Invalid JSON: " + xhr.responseText);
            return;
          }

          resolve({
            success: 1,
            file: {
              url: imageUrl,
            },
          });
        } catch (error) {
          reject("Invalid JSON: " + xhr.responseText);
        }
      };

      xhr.onerror = () => {
        reject({ message: "Image upload failed", remove: true });
      };

      xhr.send(formData);
    });
  };

  useEffect(() => {
    if (!editorRef.current) {
      editorRef.current = new EditorJS({
        holder: "editorjs",
        tools: {
          header: Header,
          list: List,
          code: CodeTool,
          delimiter: Delimiter,
          inlineCode: InlineCode,
          image: {
            class: ImageTool,
            config: {
              uploader: {
                // Sử dụng hàm upload tùy chỉnh
                uploadByFile: handleImageUpload,
                // Bạn cũng có thể thêm uploadByUrl nếu cần
                // uploadByUrl: (url: string) => { /* ... */ },
              },
            },
          },
          table: Table,
        },
        onChange: async (api, event) => {
          try {
            const content = await api.saver.save();
            console.log("Current content:", content);

            console.log(106, content.blocks);

            const html = edjsParser.parse(content);
            console.log(107, html.join(""));
            setHtml(html);
          } catch (error) {
            console.error("Error saving content:", error);
          }
        },
        data: {
          blocks: [],
        },
        onReady: async () => {
          if (props.content) {
            await editorRef.current?.blocks.renderFromHTML(
              props.content.replaceAll("<strong>", "").replaceAll("</strong>", "")
            );
          }
        },
        placeholder: "Nhập nội dung tại đây",
        // Bạn có thể thêm các cấu hình khác ở đây nếu cần
      });
    }

    return () => {
      if (editorRef.current && editorRef.current.destroy) {
        editorRef.current.destroy();
      }
    };
  }, []);

  return (
    <div className="container mx-auto p-4">
      <div id="editorjs" className="border border-gray-300 rounded-lg p-4 min-h-[300px]"></div>
      {/* <h1>HTML Preview</h1> */}
      {/* <div className="text-container">{parse(html.join(""))}</div> */}
    </div>
  );
}
